<template>
  <b-modal v-model="showEdgeModal" :title="modalTitle" size="lg">
    <div v-if="isLoadingModal" class="block block-mode-loading bg-body-dark">
      <br><br><br><br><br><br><br><br><br>
    </div>
    <transfer-between-details v-else v-for="(transfer, index) in transfers" :transfer="transfer" :account="modal.params.account[0]" :key="index" />
  </b-modal>
</template>

<script>
import TransferBetweenDetails from '@/components/common/TransferBetweenDetails'

export default {
  components: {
    TransferBetweenDetails
  },
  computed: {
    modalTitle () {
      if (this.isLoadingModal) {
        return this.$t('networkTransfers.edgeInfoModal.loading')
      } else return this.$t('networkTransfers.edgeInfoModal.transfersFromTo', { accountFrom: this.modal.params.account[0], accountTo: this.modal.params.account[1] })
    },
    modal () {
      return this.$store.state.network.modal
    },
    showEdgeModal: {
      get () {
        return this.modal.edgeModalShow
      },
      set (value) {
        this.$store.commit('toggleEdgeModal', value)
      }
    },
    transfers () {
      if (typeof this.modal.data.transfers !== 'undefined') return this.modal.data.transfers.filter(tx => tx._from._name.split('/')[1] === this.modal.params.account[0])
      else return {}
    },
    isLoadingModal () {
      return this.$store.state.options.isLoadingModal
    }
  }
}
</script>

<style>
  .modal-body {
    background-color: rgb(235, 235, 235) !important;
  }
</style>
